import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { AmountPlaceholderModule, Tv3PlatformModule } from '@tokeet/tv3-platform'
import { MatTableModule } from '@angular/material/table'
import { MatSortModule } from '@angular/material/sort'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { EditPaymentScheduleDialogComponent } from './edit-payment-schedule-dialog.component'
import { EditPaymentScheduleDialogService } from './edit-payment-schedule-dialog.service'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    Tv3PlatformModule,
    MatTableModule,
    MatInputModule,
    MatSortModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatFormFieldModule,
    AmountPlaceholderModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  declarations: [EditPaymentScheduleDialogComponent],
  providers: [EditPaymentScheduleDialogService],
  exports: [EditPaymentScheduleDialogComponent],
})
export class EditPaymentScheduleModule {}
